import Label from '@components/label';

import style from './textarea.module.scss';

const Textarea = ({
  reconciled,
  label,
  dot,
  error,
  onChange,
  className,
  placeholder,
  register,
  name,
  showReconciled = false,
  showReconcileFeatherIconWhenValueChanged = false,
  value
  // showErrorMessage = true
}) => {
  return (
    <div className={style.fieldInput}>
      <Label
        // reconciled={reconciled}
        reconciled={
          showReconcileFeatherIconWhenValueChanged
            ? showReconciled && reconciled
              ? reconciled
              : false
            : reconciled
        }
        label={label}
        dot={dot}
        // error={showErrorMessage ? error : ''}
        error={error}
        showReconciled={showReconciled}
        inLineStyle={{ paddingLeft: '8px' }}
      />
      <textarea
        name={name}
        rows={3}
        onKeyDown={(e) => {
          e.stopPropagation();
        }}
        onChange={onChange}
        placeholder={placeholder}
        className={`${style.inputField} ${className}  ${error && style.errorBorder} `}
        {...(register && register(name))}
        {...(!register && { value: value || '' })}
      ></textarea>
    </div>
  );
};

export default Textarea;
